import { parseISO } from "date-fns";
import { dateMatchesDescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import type { FundStructureDocument } from "../../../../../api/types/fundStructureTypes";
import type { FundStructureDocumentsFilterState } from "../../common/fundStructureDocumentsFilters";

const matchesSearch = (contactDocument: FundStructureDocument, searchTerm: string) =>
  contactDocument.documentCollectionName.toLowerCase().includes(searchTerm) ||
  contactDocument.name.toLowerCase().includes(searchTerm);

// Filtering by fund and investor names since contact document does not contain IDs
const matchesFilters = (contactDocument: FundStructureDocument, filter: FundStructureDocumentsFilterState) =>
  matchesSearch(contactDocument, filter.searchTerm.trim().toLowerCase()) &&
  (filter.fundIds.length === 0 || filter.fundIds.some((fundName) => contactDocument.fundNames.includes(fundName))) &&
  (filter.fundInvestorIds.length === 0 ||
    filter.fundInvestorIds.some((investorName) => contactDocument.investorNames.includes(investorName))) &&
  (filter.categoryIds.length === 0 || filter.categoryIds.includes(contactDocument.categoryId)) &&
  (filter.statuses.length === 0 || filter.statuses.includes(contactDocument.status)) &&
  (filter.dateRange === undefined ||
    dateMatchesDescriptiveDateRange(parseISO(contactDocument.sentAt), filter.dateRange));

export const filterContactDocuments = (
  allContactDocuments: FundStructureDocument[],
  filter: FundStructureDocumentsFilterState
): FundStructureDocument[] => allContactDocuments.filter((doc) => matchesFilters(doc, filter));
